import { BaseService } from "mrb/core";
import { DayHourApiRouteService } from "common/services";

class DayHourService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new DayHourApiRouteService());
    }

    get(abortSignal = null) {
        const url = this.routeService.get();
        return this.apiClient.get(url, null, null, abortSignal);
    }
}

export default DayHourService;
